import { useState, useRef } from 'react';

const FORM_URL = 'https://piccraft.github.io/api/form/d9u5475ca23r0tr1aqrg';

export default function Newsletter() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [message, setMessage] = useState('');
  const formRef = useRef<HTMLFormElement>(null);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const form = formRef.current;
    if (!form) return;

    const formData = new FormData(form);
    const honeypot = formData.get('website_alt');
    if (honeypot && (honeypot as string).trim() !== '') {
      setStatus('success');
      setMessage('订阅成功！感谢你的关注。');
      setEmail('');
      return;
    }

    setStatus('loading');

    try {
      const payload = new URLSearchParams();
      payload.append('email', email.trim());

      const resp = await fetch(FORM_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: payload.toString(),
      });

      const responseText = await resp.text();
      let parsed: Record<string, unknown> = {};
      try {
        parsed = JSON.parse(responseText);
      } catch {
        // ignore parse error
      }

      const code = (parsed as { code?: string }).code;
      const serverMsg =
        ((parsed as { meta?: { message?: string } }).meta?.message) ||
        ((parsed as { message?: string }).message) ||
        '';

      if (resp.ok && code === 'OK') {
        setStatus('success');
        setMessage('订阅成功！感谢你的关注，我们会定期发送精选摄影教程到你的邮箱。');
        setEmail('');
      } else {
        setStatus('error');
        setMessage(serverMsg || '订阅失败，请稍后重试。');
      }
    } catch {
      setStatus('error');
      setMessage('网络错误，请检查网络连接后重试。');
    }
  };

  return (
    <section className="py-14 md:py-20">
      <div className="max-w-2xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-3">
          订阅我们的 Newsletter
        </h2>
        <p className="text-foreground-600 text-sm mb-8">
          每周推送精选摄影教程、技巧干货和行业资讯，不错过任何精彩内容
        </p>
        <form ref={formRef} onSubmit={handleSubmit} data-readdy-form="" className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto">
          <input
            type="text"
            name="website_alt"
            tabIndex={-1}
            autoComplete="off"
            aria-hidden="true"
            readOnly
            className="honeypot-field"
          />
          <input
            type="email"
            name="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="输入你的邮箱地址"
            required
            className="flex-1 px-4 py-3 bg-background-50 border border-background-200 rounded-lg text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors"
          />
          <button
            type="submit"
            disabled={status === 'loading'}
            className="px-6 py-3 bg-primary-500 text-white rounded-lg font-medium text-sm hover:bg-primary-600 transition-colors disabled:opacity-50 cursor-pointer whitespace-nowrap"
          >
            {status === 'loading' ? '订阅中...' : '立即订阅'}
          </button>
        </form>
        {status === 'success' && (
          <p className="mt-4 text-sm text-green-600">{message}</p>
        )}
        {status === 'error' && (
          <p className="mt-4 text-sm text-red-500">{message}</p>
        )}
      </div>
    </section>
  );
}